import React, {useEffect} from "react";

import MensajeValidacion from "./MensajeValidacion";

/**
 * Crea un select configurado para react-hook-form permitiendo agregar una funcion onChange
 * opciones: debe ser un array [{codigo, nombre}]
 */
export default function SelectReactHookForm({regSel, handleChange, id, opciones, errors, campoKey,  valorDefault,
setState}) {    
    let valor = null;       
    
    if (valorDefault) {        
        valor = valorDefault;
    }
    
    return (
        <React.Fragment>
        <select       
        name={regSel.name}
        ref={regSel.ref}
        onChange={(e) => {
            console.log("onchange select invocado")
            regSel.onChange(e);
            // este setstate es necesario para que el select no se quede pegado en el valor anterior.
            if (setState) {
               setState({[id]: e.target.value})
            }
            if (handleChange)
                handleChange(e);
        }}
        onBlur={(e) => {
            regSel.onBlur(e);
        }}
        id={id}
        value={valor}>            
        {
            opciones && (
                opciones.map((o, index) => {
                    let key = campoKey ? o[campoKey] : o.codigo
                  
                    return (
                        <option value={o.codigo} key={key}>
                            {o.nombre}
                        </option>
                    );

                })
            )
        }
        </select>       
      
        <MensajeValidacion nombre={regSel.name} errors={errors}/>
        </React.Fragment>
    );
}